var SliderArranger        = require("enyo-ui/SliderArranger"),
    SliderSlideTransition = require("enyo-ui/SliderSlideTransition"),
    kind                  = require("enyo/kind");

require("enyo-ui");

/**
 * [SliderSlideArranger]{@link enyo-ui.SliderSlideArranger} is an arranger for
 * [Slider]{@link enyo-ui.Slider} that provides transitions such that both
 * activating and deactivating slides animate to slide into or out of view at
 * the same time.
 *
 * @ui
 * @class   enyo-ui.SliderSlideArranger
 * @extends enyo-ui.SliderArranger
 * @public
 */
module.exports = kind(/** @lends  enyo-ui.SliderSlideArranger.prototype */ {

    /**
     * @private
     */
    name: "enyo-ui.SliderSlideArranger",

    /**
     * @private
     */
    kind: SliderArranger,

    /**
     * Default options for the arranger.
     *
     * @type {Object}
     * @protected
     */
    options: {

        /**
         * Returns the transition kind.
         *
         * It's impossible to tell if an option is computed or if its value is
         * supposed to be a constructor. To break this paradox we wrap the
         * constructor in a function.
         *
         * @returns {enyo-ui.SliderTransition} The transition
         * @public
         */
        transitionKind: function() {
            return SliderSlideTransition;
        }
    },

    /**
     * Snap to the slide.
     *
     * @param {enyo.Control}  slide  The slide
     * @public
     */
    snapTo: function(slide) {
        var slider          = this.slider,
            activeSlide     = slider.activeSlide,
            activatingSlide = slider.activatingSlide;

        if (activeSlide && activeSlide !== slide) {
            activeSlide.sliderTransition.snapToInactive();
        }

        if (activatingSlide && activatingSlide !== slide) {
            // The fact that the slide is activating implies it's animating. In
            // this case we don't snap but simply reverse the transition, it's
            // less visually jarring.
            activatingSlide.sliderTransition.transitionToInactive();
        }

        this.stackSlideOnTop(slide);
        slide.sliderTransition.snapToActive();
    },

    /**
     * Initiate a transition to the slide.
     *
     * @param {enyo.Control}  slide      The slide
     * @param {number}        index      The index of the slide
     * @param {string}        direction  The direction of the transition
     * @public
     */
    transitionTo: function(slide, index, direction) {
        var slider          = this.slider,
            activeSlide     = slider.activeSlide,
            activatingSlide = slider.activatingSlide;

        if (activeSlide && activeSlide !== slide) {
            activeSlide.sliderTransition.transitionToInactive(direction);
        }

        if (activatingSlide && activatingSlide !== slide) {
            activatingSlide.sliderTransition.transitionToInactive(direction);
        }

        this.stackSlideOnTop(slide);
        slide.sliderTransition.transitionToActive(direction);
    }

});
